<template>
  <ModalDefault modal_id="addSubmenuModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="bots.new.bot_id === null ? getTranslations('expression_859') : getTranslations('expression_860')"
                :footer="bots.new.option && bots.new.label"
                icon="bx bx-menu mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="d-flex">
          <div class="file-upload-center cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block pt-2 px-2">
              <div class="row">
                <div class="col-2">
                  <label class="mb-0">{{ getTranslations('expression_341') }}</label>
                  <div class="input-group mb-4">
                    <input type="number"
                           class="input_forms form-control"
                           v-model="bots.new.option">
                  </div>
                </div>
                <div class="col-10 mb-4">
                  <label class="mb-0">{{ getTranslations('expression_343') }}</label>
                  <div class="input-group">
                    <input type="text"
                           class="input_forms form-control"
                           v-model="bots.new.label" maxlength="30">
                  </div>
                  <div style="display: flex;justify-content: flex-end;width: 100%;">
                    <TextCount class="text-end" :length="bots.new.label ? bots.new.label.length : 0" limit="30"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span @click.prevent="saveBot"
                data-dismiss="modal"
                class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_120') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import TextCount from "../general/TextCount";

export default {
  name: "ModalAddSubmenuChatBot",
  components: {
    TextCount,
    ModalDefault,
  },
  computed: {
    ...mapState(['bots', 'channels', 'bots']),
    ...mapGetters([])
  },
  methods: {
    saveBot(){
      this.$store.dispatch("addBot", this.bots.new)
    },
  }
}
</script>

<style scoped>

</style>
